/**
 * / 区切りの日時を、ISO8601風のフォーマットに変換する
 *
 * @param dateString
 * @param withTime
 * @returns string
 */

export default function convertToISOLikeFormat(
  dateString: string,
  withTime: boolean = true,
): string {
  const datePattern = /^\d{4}\/\d{2}\/\d{2}$/
  const timePattern = `T00:00:00+09:00`

  if (!datePattern.test(dateString)) {
    throw new Error('不正なフォーマットです. Expected YYYY/MM/DD.')
  }

  const [year, month, day] = dateString.split('/')

  return withTime
    ? `${year}-${month}-${day}${timePattern}`
    : `${year}-${month}-${day}`
}
